import styles from './styles.scss';
import React from 'react';
import {Button} from 'react-weui'


export default (props) => {

  const { error, onRefresh } = props;

  return (
    <div className={styles.errorBox}>
      <label className={styles.errorText}>{error}</label>

      <Button type="default" size="small" onClick={()=>{
        onRefresh && onRefresh();
      }}>刷新</Button>
    </div>
  )
}
